import React from "react";
import classes from "./MobileVersion.module.scss";

const MobileVersion = () => {
  return (
    <div
      className={`w-100 ${classes.container} d-flex align-items-center justify-content-center`}
    >
      <p>Please visit the desktop version.</p>
    </div>
  );
};

export default MobileVersion;
